import { Rectangle, Popup } from 'react-leaflet';
import type { LatLngBoundsExpression } from 'leaflet';

// Minimal type for rendering - component accepts any object with these properties
interface MetroBase {
  id: string;
  name: string;
  neLatitude: string;
  neLongitude: string;
  swLatitude: string;
  swLongitude: string;
  regionCount?: number;
  barCount?: number;
  isActive?: boolean;
}

interface MetroBoundsProps<T extends MetroBase> {
  metro: T;
  selected?: boolean;
  onClick?: (metro: T) => void;
  color?: string;
}

export function MetroBounds<T extends MetroBase>({ metro, selected, onClick, color }: MetroBoundsProps<T>) {
  // Validate coordinates exist before rendering
  if (
    metro.swLatitude == null ||
    metro.swLongitude == null ||
    metro.neLatitude == null ||
    metro.neLongitude == null
  ) {
    console.warn(`MetroBounds: Invalid coordinates for metro "${metro.name}"`, metro);
    return null;
  }

  const bounds: LatLngBoundsExpression = [
    [Number(metro.swLatitude), Number(metro.swLongitude)],
    [Number(metro.neLatitude), Number(metro.neLongitude)]
  ];

  const fillColor = color || (metro.isActive ? '#22c55e' : '#ef4444');
  const strokeColor = selected ? '#3b82f6' : fillColor;

  return (
    <Rectangle
      bounds={bounds}
      pathOptions={{
        color: strokeColor,
        fillColor,
        fillOpacity: selected ? 0.3 : 0.15,
        weight: selected ? 3 : 2
      }}
      eventHandlers={{
        click: () => onClick?.(metro)
      }}
    >
      <Popup>
        <div className="text-sm">
          <div className="font-semibold">{metro.name}</div>
          {metro.regionCount !== undefined && (
            <div className="text-gray-600">{metro.regionCount} regions</div>
          )}
          {metro.barCount !== undefined && (
            <div className="text-gray-600">{metro.barCount} bars</div>
          )}
        </div>
      </Popup>
    </Rectangle>
  );
}
